<script>
	const relationRes = {
		title: '数据关系',
		rule: {
			"width": "1400",
			"height": "800",
			"fApi": [],
			"rule": [{
				"type": "$relationGraph",
				"field": "relation",
				"name": "数据关系图",
				"value": null,
				"props": {
					"width": "1340",
					"height": "650"
				},
				"validate": [{
					"required": false,
					"message": "必填项"
				}]
			}],
			"option": {
				"form": {
					"labelWidth": "80px",
					"hideRequiredAsterisk": false,
					"showMessage": false,
					"inlineMessage": false
				},
				"global": {
					"*": {
						"props": {
							"el": true,
							"size": "small",
							"disabled": false
						}
					}
				},
				"submitBtn": false,
				"resetBtn": false
			}
		}
	}
	import formBase from '@_system/components/base/form.vue'
	export default {
		extends: formBase,
		name: 'relationForm',
		props: {

		},
		data() {
			return {

			}

		},

		watch: {

		},
		computed: {

		},
		created() {

		},
		mounted() {

		},
		methods: {
			init() {
				new Promise((resolve) => {
					if (this.beforeInit) {
						this.beforeInit(resolve)
					} else {
						resolve()
					}
				}).then(() => {
	
					let res = JSON.parse(JSON.stringify(relationRes))
					this.rule = res.rule
					if (this.extra.defaultvalue) {
						for (let i in this.extra.defaultvalue) {
							for (let j in this.rule.rule) {
								if (this.rule.rule[j].field == i) {
									this.rule.rule[j].value = this.extra.defaultvalue[i]
								}
							}
						}
					}
					this.title = res.title
					this.width = res.rule.width
					this.height = res.rule.height

					this.openwindow()


				})
			},
			regestEvent() {
				//console.log(this.fApi.fields())
				this.fApi.mergeRule('relation', {
					props: {
						extra: this.extra
					}
				})
				this.$nextTick(() => {
					this.fApi.el('relation').get()
				})
			},
			afterGet(data) {
				console.log(data)
			},
			beforeSubmit(formData, next) {
				formData.flow = JSON.stringify(formData.flow)
				next()
			},
			submit() {
				let relation = this.fApi.el('relation')
				let data = relation.submit()
				// console.log(JSON.stringify(data.json))
				this.$api.form.saveRelation(data.controllName, {
					json: JSON.stringify(data.json)
				}).then(()=>{
					window.close()
				})
				
				
				// this.$emit('back', {
				// 	type: 'cancle'
				// })
			},
		},
		components: {

		}
	}
</script>
